/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorkflowsRouteImport } from './routes/workflows'
import { Route as TermsOfServiceRouteImport } from './routes/terms-of-service'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ReleaseNotesRouteImport } from './routes/release-notes'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IntegrationsRouteImport } from './routes/integrations'
import { Route as HomepageRouteImport } from './routes/homepage'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as CompareRouteImport } from './routes/compare'
import { Route as ChangelogRouteImport } from './routes/changelog'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AboutRouteImport } from './routes/about'
import { Route as WorkspaceRouteImport } from './routes/_workspace'
import { Route as WorkspaceIndexRouteImport } from './routes/_workspace.index'
import { Route as WorkflowsSlugRouteImport } from './routes/workflows_.$slug'
import { Route as UseCasesSupportRouteImport } from './routes/use-cases.support'
import { Route as UseCasesQaRouteImport } from './routes/use-cases.qa'
import { Route as UseCasesProductRouteImport } from './routes/use-cases.product'
import { Route as UseCasesEngineeringRouteImport } from './routes/use-cases.engineering'
import { Route as UseCasesAgenciesRouteImport } from './routes/use-cases.agencies'
import { Route as SourceControlCallbackRouteImport } from './routes/source-control.callback'
import { Route as ServicesMaitoSetupRouteImport } from './routes/services.maito-setup'
import { Route as ReleaseNotesSlugRouteImport } from './routes/release-notes_.$slug'
import { Route as ProductTeamCollaborationRouteImport } from './routes/product.team-collaboration'
import { Route as ProductSkillsRouteImport } from './routes/product.skills'
import { Route as ProductCompanyKnowledgeRouteImport } from './routes/product.company-knowledge'
import { Route as IntegrationsSlugRouteImport } from './routes/integrations_.$slug'
import { Route as CompareSlugRouteImport } from './routes/compare_.$slug'
import { Route as ChangelogSlugRouteImport } from './routes/changelog_.$slug'
import { Route as BlogSlugRouteImport } from './routes/blog_.$slug'
import { Route as WorkspaceVaultRouteImport } from './routes/_workspace.vault'
import { Route as WorkspaceUsageRouteImport } from './routes/_workspace.usage'
import { Route as WorkspaceSlackRouteImport } from './routes/_workspace.slack'
import { Route as WorkspaceSkillsRouteImport } from './routes/_workspace.skills'
import { Route as WorkspaceRepositoriesRouteImport } from './routes/_workspace.repositories'
import { Route as WorkspaceProvidersRouteImport } from './routes/_workspace.providers'
import { Route as WorkspaceProfileRouteImport } from './routes/_workspace.profile'
import { Route as WorkspaceOverviewRouteImport } from './routes/_workspace.overview'
import { Route as WorkspaceMembersRouteImport } from './routes/_workspace.members'
import { Route as WorkspaceMcpRouteImport } from './routes/_workspace.mcp'
import { Route as WorkspaceLoopsRouteImport } from './routes/_workspace.loops'
import { Route as WorkspaceLogsRouteImport } from './routes/_workspace.logs'
import { Route as WorkspaceKnowledgeRouteImport } from './routes/_workspace.knowledge'
import { Route as WorkspaceGeneralRouteImport } from './routes/_workspace.general'
import { Route as WorkspaceEnvironmentsRouteImport } from './routes/_workspace.environments'
import { Route as WorkspaceEmailRouteImport } from './routes/_workspace.email'
import { Route as WorkspaceCreateRouteImport } from './routes/_workspace.create'
import { Route as WorkspaceConnectionsRouteImport } from './routes/_workspace.connections'
import { Route as WorkspaceChatRouteImport } from './routes/_workspace.chat'
import { Route as WorkspaceArchivedRouteImport } from './routes/_workspace.archived'
import { Route as WorkflowsToolToolRouteImport } from './routes/workflows_.tool.$tool'
import { Route as WorkflowsTeamTeamRouteImport } from './routes/workflows_.team.$team'
import { Route as WorkflowsIndustryIndustryRouteImport } from './routes/workflows_.industry.$industry'
import { Route as IntegrationsCategoryCategoryRouteImport } from './routes/integrations_.category.$category'
import { Route as BlogCategoryAiNewsRouteImport } from './routes/blog_.category.ai-news'
import { Route as WorkspaceHomeChar123LoopChar125RouteImport } from './routes/_workspace.home.{-$loop}'
import { Route as WorkspaceConnectionsMcpRouteImport } from './routes/_workspace.connections_.mcp'
import { Route as WorkspaceActivityChar123LoopChar125RouteImport } from './routes/_workspace.activity.{-$loop}'

const WorkflowsRoute = WorkflowsRouteImport.update({
  id: '/workflows',
  path: '/workflows',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsOfServiceRoute = TermsOfServiceRouteImport.update({
  id: '/terms-of-service',
  path: '/terms-of-service',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const ReleaseNotesRoute = ReleaseNotesRouteImport.update({
  id: '/release-notes',
  path: '/release-notes',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsRoute = IntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => rootRouteImport,
} as any)
const HomepageRoute = HomepageRouteImport.update({
  id: '/homepage',
  path: '/homepage',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqRoute = FaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const CompareRoute = CompareRouteImport.update({
  id: '/compare',
  path: '/compare',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangelogRoute = ChangelogRouteImport.update({
  id: '/changelog',
  path: '/changelog',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogRoute = BlogRouteImport.update({
  id: '/blog',
  path: '/blog',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceRoute = WorkspaceRouteImport.update({
  id: '/_workspace',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceIndexRoute = WorkspaceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkflowsSlugRoute = WorkflowsSlugRouteImport.update({
  id: '/workflows_/$slug',
  path: '/workflows/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const UseCasesSupportRoute = UseCasesSupportRouteImport.update({
  id: '/use-cases/support',
  path: '/use-cases/support',
  getParentRoute: () => rootRouteImport,
} as any)
const UseCasesQaRoute = UseCasesQaRouteImport.update({
  id: '/use-cases/qa',
  path: '/use-cases/qa',
  getParentRoute: () => rootRouteImport,
} as any)
const UseCasesProductRoute = UseCasesProductRouteImport.update({
  id: '/use-cases/product',
  path: '/use-cases/product',
  getParentRoute: () => rootRouteImport,
} as any)
const UseCasesEngineeringRoute = UseCasesEngineeringRouteImport.update({
  id: '/use-cases/engineering',
  path: '/use-cases/engineering',
  getParentRoute: () => rootRouteImport,
} as any)
const UseCasesAgenciesRoute = UseCasesAgenciesRouteImport.update({
  id: '/use-cases/agencies',
  path: '/use-cases/agencies',
  getParentRoute: () => rootRouteImport,
} as any)
const SourceControlCallbackRoute = SourceControlCallbackRouteImport.update({
  id: '/source-control/callback',
  path: '/source-control/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesMaitoSetupRoute = ServicesMaitoSetupRouteImport.update({
  id: '/services/maito-setup',
  path: '/services/maito-setup',
  getParentRoute: () => rootRouteImport,
} as any)
const ReleaseNotesSlugRoute = ReleaseNotesSlugRouteImport.update({
  id: '/release-notes_/$slug',
  path: '/release-notes/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductTeamCollaborationRoute =
  ProductTeamCollaborationRouteImport.update({
    id: '/product/team-collaboration',
    path: '/product/team-collaboration',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProductSkillsRoute = ProductSkillsRouteImport.update({
  id: '/product/skills',
  path: '/product/skills',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductCompanyKnowledgeRoute = ProductCompanyKnowledgeRouteImport.update({
  id: '/product/company-knowledge',
  path: '/product/company-knowledge',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsSlugRoute = IntegrationsSlugRouteImport.update({
  id: '/integrations_/$slug',
  path: '/integrations/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const CompareSlugRoute = CompareSlugRouteImport.update({
  id: '/compare_/$slug',
  path: '/compare/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangelogSlugRoute = ChangelogSlugRouteImport.update({
  id: '/changelog_/$slug',
  path: '/changelog/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogSlugRoute = BlogSlugRouteImport.update({
  id: '/blog_/$slug',
  path: '/blog/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceVaultRoute = WorkspaceVaultRouteImport.update({
  id: '/vault',
  path: '/vault',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceUsageRoute = WorkspaceUsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceSlackRoute = WorkspaceSlackRouteImport.update({
  id: '/slack',
  path: '/slack',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceSkillsRoute = WorkspaceSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceRepositoriesRoute = WorkspaceRepositoriesRouteImport.update({
  id: '/repositories',
  path: '/repositories',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceProvidersRoute = WorkspaceProvidersRouteImport.update({
  id: '/providers',
  path: '/providers',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceProfileRoute = WorkspaceProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceOverviewRoute = WorkspaceOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceMembersRoute = WorkspaceMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceMcpRoute = WorkspaceMcpRouteImport.update({
  id: '/mcp',
  path: '/mcp',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceLoopsRoute = WorkspaceLoopsRouteImport.update({
  id: '/loops',
  path: '/loops',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceLogsRoute = WorkspaceLogsRouteImport.update({
  id: '/logs',
  path: '/logs',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceKnowledgeRoute = WorkspaceKnowledgeRouteImport.update({
  id: '/knowledge',
  path: '/knowledge',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceGeneralRoute = WorkspaceGeneralRouteImport.update({
  id: '/general',
  path: '/general',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceEnvironmentsRoute = WorkspaceEnvironmentsRouteImport.update({
  id: '/environments',
  path: '/environments',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceEmailRoute = WorkspaceEmailRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceCreateRoute = WorkspaceCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceConnectionsRoute = WorkspaceConnectionsRouteImport.update({
  id: '/connections',
  path: '/connections',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceChatRoute = WorkspaceChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceArchivedRoute = WorkspaceArchivedRouteImport.update({
  id: '/archived',
  path: '/archived',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkflowsToolToolRoute = WorkflowsToolToolRouteImport.update({
  id: '/workflows_/tool/$tool',
  path: '/workflows/tool/$tool',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkflowsTeamTeamRoute = WorkflowsTeamTeamRouteImport.update({
  id: '/workflows_/team/$team',
  path: '/workflows/team/$team',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkflowsIndustryIndustryRoute =
  WorkflowsIndustryIndustryRouteImport.update({
    id: '/workflows_/industry/$industry',
    path: '/workflows/industry/$industry',
    getParentRoute: () => rootRouteImport,
  } as any)
const IntegrationsCategoryCategoryRoute =
  IntegrationsCategoryCategoryRouteImport.update({
    id: '/integrations_/category/$category',
    path: '/integrations/category/$category',
    getParentRoute: () => rootRouteImport,
  } as any)
const BlogCategoryAiNewsRoute = BlogCategoryAiNewsRouteImport.update({
  id: '/blog_/category/ai-news',
  path: '/blog/category/ai-news',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceHomeChar123LoopChar125Route =
  WorkspaceHomeChar123LoopChar125RouteImport.update({
    id: '/home/{-$loop}',
    path: '/home/{-$loop}',
    getParentRoute: () => WorkspaceRoute,
  } as any)
const WorkspaceConnectionsMcpRoute = WorkspaceConnectionsMcpRouteImport.update({
  id: '/connections_/mcp',
  path: '/connections/mcp',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceActivityChar123LoopChar125Route =
  WorkspaceActivityChar123LoopChar125RouteImport.update({
    id: '/activity/{-$loop}',
    path: '/activity/{-$loop}',
    getParentRoute: () => WorkspaceRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof WorkspaceIndexRoute
  '/about': typeof AboutRoute
  '/admin': typeof AdminRoute
  '/blog': typeof BlogRoute
  '/changelog': typeof ChangelogRoute
  '/compare': typeof CompareRoute
  '/faq': typeof FaqRoute
  '/homepage': typeof HomepageRoute
  '/integrations': typeof IntegrationsRoute
  '/login': typeof LoginRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/release-notes': typeof ReleaseNotesRoute
  '/terms': typeof TermsRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/workflows': typeof WorkflowsRoute
  '/archived': typeof WorkspaceArchivedRoute
  '/chat': typeof WorkspaceChatRoute
  '/connections': typeof WorkspaceConnectionsRoute
  '/create': typeof WorkspaceCreateRoute
  '/email': typeof WorkspaceEmailRoute
  '/environments': typeof WorkspaceEnvironmentsRoute
  '/general': typeof WorkspaceGeneralRoute
  '/knowledge': typeof WorkspaceKnowledgeRoute
  '/logs': typeof WorkspaceLogsRoute
  '/loops': typeof WorkspaceLoopsRoute
  '/mcp': typeof WorkspaceMcpRoute
  '/members': typeof WorkspaceMembersRoute
  '/overview': typeof WorkspaceOverviewRoute
  '/profile': typeof WorkspaceProfileRoute
  '/providers': typeof WorkspaceProvidersRoute
  '/repositories': typeof WorkspaceRepositoriesRoute
  '/skills': typeof WorkspaceSkillsRoute
  '/slack': typeof WorkspaceSlackRoute
  '/usage': typeof WorkspaceUsageRoute
  '/vault': typeof WorkspaceVaultRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/changelog/$slug': typeof ChangelogSlugRoute
  '/compare/$slug': typeof CompareSlugRoute
  '/integrations/$slug': typeof IntegrationsSlugRoute
  '/product/company-knowledge': typeof ProductCompanyKnowledgeRoute
  '/product/skills': typeof ProductSkillsRoute
  '/product/team-collaboration': typeof ProductTeamCollaborationRoute
  '/release-notes/$slug': typeof ReleaseNotesSlugRoute
  '/services/maito-setup': typeof ServicesMaitoSetupRoute
  '/source-control/callback': typeof SourceControlCallbackRoute
  '/use-cases/agencies': typeof UseCasesAgenciesRoute
  '/use-cases/engineering': typeof UseCasesEngineeringRoute
  '/use-cases/product': typeof UseCasesProductRoute
  '/use-cases/qa': typeof UseCasesQaRoute
  '/use-cases/support': typeof UseCasesSupportRoute
  '/workflows/$slug': typeof WorkflowsSlugRoute
  '/activity/{-$loop}': typeof WorkspaceActivityChar123LoopChar125Route
  '/connections/mcp': typeof WorkspaceConnectionsMcpRoute
  '/home/{-$loop}': typeof WorkspaceHomeChar123LoopChar125Route
  '/blog/category/ai-news': typeof BlogCategoryAiNewsRoute
  '/integrations/category/$category': typeof IntegrationsCategoryCategoryRoute
  '/workflows/industry/$industry': typeof WorkflowsIndustryIndustryRoute
  '/workflows/team/$team': typeof WorkflowsTeamTeamRoute
  '/workflows/tool/$tool': typeof WorkflowsToolToolRoute
}
export interface FileRoutesByTo {
  '/about': typeof AboutRoute
  '/admin': typeof AdminRoute
  '/blog': typeof BlogRoute
  '/changelog': typeof ChangelogRoute
  '/compare': typeof CompareRoute
  '/faq': typeof FaqRoute
  '/homepage': typeof HomepageRoute
  '/integrations': typeof IntegrationsRoute
  '/login': typeof LoginRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/release-notes': typeof ReleaseNotesRoute
  '/terms': typeof TermsRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/workflows': typeof WorkflowsRoute
  '/archived': typeof WorkspaceArchivedRoute
  '/chat': typeof WorkspaceChatRoute
  '/connections': typeof WorkspaceConnectionsRoute
  '/create': typeof WorkspaceCreateRoute
  '/email': typeof WorkspaceEmailRoute
  '/environments': typeof WorkspaceEnvironmentsRoute
  '/general': typeof WorkspaceGeneralRoute
  '/knowledge': typeof WorkspaceKnowledgeRoute
  '/logs': typeof WorkspaceLogsRoute
  '/loops': typeof WorkspaceLoopsRoute
  '/mcp': typeof WorkspaceMcpRoute
  '/members': typeof WorkspaceMembersRoute
  '/overview': typeof WorkspaceOverviewRoute
  '/profile': typeof WorkspaceProfileRoute
  '/providers': typeof WorkspaceProvidersRoute
  '/repositories': typeof WorkspaceRepositoriesRoute
  '/skills': typeof WorkspaceSkillsRoute
  '/slack': typeof WorkspaceSlackRoute
  '/usage': typeof WorkspaceUsageRoute
  '/vault': typeof WorkspaceVaultRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/changelog/$slug': typeof ChangelogSlugRoute
  '/compare/$slug': typeof CompareSlugRoute
  '/integrations/$slug': typeof IntegrationsSlugRoute
  '/product/company-knowledge': typeof ProductCompanyKnowledgeRoute
  '/product/skills': typeof ProductSkillsRoute
  '/product/team-collaboration': typeof ProductTeamCollaborationRoute
  '/release-notes/$slug': typeof ReleaseNotesSlugRoute
  '/services/maito-setup': typeof ServicesMaitoSetupRoute
  '/source-control/callback': typeof SourceControlCallbackRoute
  '/use-cases/agencies': typeof UseCasesAgenciesRoute
  '/use-cases/engineering': typeof UseCasesEngineeringRoute
  '/use-cases/product': typeof UseCasesProductRoute
  '/use-cases/qa': typeof UseCasesQaRoute
  '/use-cases/support': typeof UseCasesSupportRoute
  '/workflows/$slug': typeof WorkflowsSlugRoute
  '/': typeof WorkspaceIndexRoute
  '/activity/{-$loop}': typeof WorkspaceActivityChar123LoopChar125Route
  '/connections/mcp': typeof WorkspaceConnectionsMcpRoute
  '/home/{-$loop}': typeof WorkspaceHomeChar123LoopChar125Route
  '/blog/category/ai-news': typeof BlogCategoryAiNewsRoute
  '/integrations/category/$category': typeof IntegrationsCategoryCategoryRoute
  '/workflows/industry/$industry': typeof WorkflowsIndustryIndustryRoute
  '/workflows/team/$team': typeof WorkflowsTeamTeamRoute
  '/workflows/tool/$tool': typeof WorkflowsToolToolRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_workspace': typeof WorkspaceRouteWithChildren
  '/about': typeof AboutRoute
  '/admin': typeof AdminRoute
  '/blog': typeof BlogRoute
  '/changelog': typeof ChangelogRoute
  '/compare': typeof CompareRoute
  '/faq': typeof FaqRoute
  '/homepage': typeof HomepageRoute
  '/integrations': typeof IntegrationsRoute
  '/login': typeof LoginRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/release-notes': typeof ReleaseNotesRoute
  '/terms': typeof TermsRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/workflows': typeof WorkflowsRoute
  '/_workspace/archived': typeof WorkspaceArchivedRoute
  '/_workspace/chat': typeof WorkspaceChatRoute
  '/_workspace/connections': typeof WorkspaceConnectionsRoute
  '/_workspace/create': typeof WorkspaceCreateRoute
  '/_workspace/email': typeof WorkspaceEmailRoute
  '/_workspace/environments': typeof WorkspaceEnvironmentsRoute
  '/_workspace/general': typeof WorkspaceGeneralRoute
  '/_workspace/knowledge': typeof WorkspaceKnowledgeRoute
  '/_workspace/logs': typeof WorkspaceLogsRoute
  '/_workspace/loops': typeof WorkspaceLoopsRoute
  '/_workspace/mcp': typeof WorkspaceMcpRoute
  '/_workspace/members': typeof WorkspaceMembersRoute
  '/_workspace/overview': typeof WorkspaceOverviewRoute
  '/_workspace/profile': typeof WorkspaceProfileRoute
  '/_workspace/providers': typeof WorkspaceProvidersRoute
  '/_workspace/repositories': typeof WorkspaceRepositoriesRoute
  '/_workspace/skills': typeof WorkspaceSkillsRoute
  '/_workspace/slack': typeof WorkspaceSlackRoute
  '/_workspace/usage': typeof WorkspaceUsageRoute
  '/_workspace/vault': typeof WorkspaceVaultRoute
  '/blog_/$slug': typeof BlogSlugRoute
  '/changelog_/$slug': typeof ChangelogSlugRoute
  '/compare_/$slug': typeof CompareSlugRoute
  '/integrations_/$slug': typeof IntegrationsSlugRoute
  '/product/company-knowledge': typeof ProductCompanyKnowledgeRoute
  '/product/skills': typeof ProductSkillsRoute
  '/product/team-collaboration': typeof ProductTeamCollaborationRoute
  '/release-notes_/$slug': typeof ReleaseNotesSlugRoute
  '/services/maito-setup': typeof ServicesMaitoSetupRoute
  '/source-control/callback': typeof SourceControlCallbackRoute
  '/use-cases/agencies': typeof UseCasesAgenciesRoute
  '/use-cases/engineering': typeof UseCasesEngineeringRoute
  '/use-cases/product': typeof UseCasesProductRoute
  '/use-cases/qa': typeof UseCasesQaRoute
  '/use-cases/support': typeof UseCasesSupportRoute
  '/workflows_/$slug': typeof WorkflowsSlugRoute
  '/_workspace/': typeof WorkspaceIndexRoute
  '/_workspace/activity/{-$loop}': typeof WorkspaceActivityChar123LoopChar125Route
  '/_workspace/connections_/mcp': typeof WorkspaceConnectionsMcpRoute
  '/_workspace/home/{-$loop}': typeof WorkspaceHomeChar123LoopChar125Route
  '/blog_/category/ai-news': typeof BlogCategoryAiNewsRoute
  '/integrations_/category/$category': typeof IntegrationsCategoryCategoryRoute
  '/workflows_/industry/$industry': typeof WorkflowsIndustryIndustryRoute
  '/workflows_/team/$team': typeof WorkflowsTeamTeamRoute
  '/workflows_/tool/$tool': typeof WorkflowsToolToolRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/admin'
    | '/blog'
    | '/changelog'
    | '/compare'
    | '/faq'
    | '/homepage'
    | '/integrations'
    | '/login'
    | '/pricing'
    | '/privacy'
    | '/privacy-policy'
    | '/release-notes'
    | '/terms'
    | '/terms-of-service'
    | '/workflows'
    | '/archived'
    | '/chat'
    | '/connections'
    | '/create'
    | '/email'
    | '/environments'
    | '/general'
    | '/knowledge'
    | '/logs'
    | '/loops'
    | '/mcp'
    | '/members'
    | '/overview'
    | '/profile'
    | '/providers'
    | '/repositories'
    | '/skills'
    | '/slack'
    | '/usage'
    | '/vault'
    | '/blog/$slug'
    | '/changelog/$slug'
    | '/compare/$slug'
    | '/integrations/$slug'
    | '/product/company-knowledge'
    | '/product/skills'
    | '/product/team-collaboration'
    | '/release-notes/$slug'
    | '/services/maito-setup'
    | '/source-control/callback'
    | '/use-cases/agencies'
    | '/use-cases/engineering'
    | '/use-cases/product'
    | '/use-cases/qa'
    | '/use-cases/support'
    | '/workflows/$slug'
    | '/activity/{-$loop}'
    | '/connections/mcp'
    | '/home/{-$loop}'
    | '/blog/category/ai-news'
    | '/integrations/category/$category'
    | '/workflows/industry/$industry'
    | '/workflows/team/$team'
    | '/workflows/tool/$tool'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/about'
    | '/admin'
    | '/blog'
    | '/changelog'
    | '/compare'
    | '/faq'
    | '/homepage'
    | '/integrations'
    | '/login'
    | '/pricing'
    | '/privacy'
    | '/privacy-policy'
    | '/release-notes'
    | '/terms'
    | '/terms-of-service'
    | '/workflows'
    | '/archived'
    | '/chat'
    | '/connections'
    | '/create'
    | '/email'
    | '/environments'
    | '/general'
    | '/knowledge'
    | '/logs'
    | '/loops'
    | '/mcp'
    | '/members'
    | '/overview'
    | '/profile'
    | '/providers'
    | '/repositories'
    | '/skills'
    | '/slack'
    | '/usage'
    | '/vault'
    | '/blog/$slug'
    | '/changelog/$slug'
    | '/compare/$slug'
    | '/integrations/$slug'
    | '/product/company-knowledge'
    | '/product/skills'
    | '/product/team-collaboration'
    | '/release-notes/$slug'
    | '/services/maito-setup'
    | '/source-control/callback'
    | '/use-cases/agencies'
    | '/use-cases/engineering'
    | '/use-cases/product'
    | '/use-cases/qa'
    | '/use-cases/support'
    | '/workflows/$slug'
    | '/'
    | '/activity/{-$loop}'
    | '/connections/mcp'
    | '/home/{-$loop}'
    | '/blog/category/ai-news'
    | '/integrations/category/$category'
    | '/workflows/industry/$industry'
    | '/workflows/team/$team'
    | '/workflows/tool/$tool'
  id:
    | '__root__'
    | '/_workspace'
    | '/about'
    | '/admin'
    | '/blog'
    | '/changelog'
    | '/compare'
    | '/faq'
    | '/homepage'
    | '/integrations'
    | '/login'
    | '/pricing'
    | '/privacy'
    | '/privacy-policy'
    | '/release-notes'
    | '/terms'
    | '/terms-of-service'
    | '/workflows'
    | '/_workspace/archived'
    | '/_workspace/chat'
    | '/_workspace/connections'
    | '/_workspace/create'
    | '/_workspace/email'
    | '/_workspace/environments'
    | '/_workspace/general'
    | '/_workspace/knowledge'
    | '/_workspace/logs'
    | '/_workspace/loops'
    | '/_workspace/mcp'
    | '/_workspace/members'
    | '/_workspace/overview'
    | '/_workspace/profile'
    | '/_workspace/providers'
    | '/_workspace/repositories'
    | '/_workspace/skills'
    | '/_workspace/slack'
    | '/_workspace/usage'
    | '/_workspace/vault'
    | '/blog_/$slug'
    | '/changelog_/$slug'
    | '/compare_/$slug'
    | '/integrations_/$slug'
    | '/product/company-knowledge'
    | '/product/skills'
    | '/product/team-collaboration'
    | '/release-notes_/$slug'
    | '/services/maito-setup'
    | '/source-control/callback'
    | '/use-cases/agencies'
    | '/use-cases/engineering'
    | '/use-cases/product'
    | '/use-cases/qa'
    | '/use-cases/support'
    | '/workflows_/$slug'
    | '/_workspace/'
    | '/_workspace/activity/{-$loop}'
    | '/_workspace/connections_/mcp'
    | '/_workspace/home/{-$loop}'
    | '/blog_/category/ai-news'
    | '/integrations_/category/$category'
    | '/workflows_/industry/$industry'
    | '/workflows_/team/$team'
    | '/workflows_/tool/$tool'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  WorkspaceRoute: typeof WorkspaceRouteWithChildren
  AboutRoute: typeof AboutRoute
  AdminRoute: typeof AdminRoute
  BlogRoute: typeof BlogRoute
  ChangelogRoute: typeof ChangelogRoute
  CompareRoute: typeof CompareRoute
  FaqRoute: typeof FaqRoute
  HomepageRoute: typeof HomepageRoute
  IntegrationsRoute: typeof IntegrationsRoute
  LoginRoute: typeof LoginRoute
  PricingRoute: typeof PricingRoute
  PrivacyRoute: typeof PrivacyRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  ReleaseNotesRoute: typeof ReleaseNotesRoute
  TermsRoute: typeof TermsRoute
  TermsOfServiceRoute: typeof TermsOfServiceRoute
  WorkflowsRoute: typeof WorkflowsRoute
  BlogSlugRoute: typeof BlogSlugRoute
  ChangelogSlugRoute: typeof ChangelogSlugRoute
  CompareSlugRoute: typeof CompareSlugRoute
  IntegrationsSlugRoute: typeof IntegrationsSlugRoute
  ProductCompanyKnowledgeRoute: typeof ProductCompanyKnowledgeRoute
  ProductSkillsRoute: typeof ProductSkillsRoute
  ProductTeamCollaborationRoute: typeof ProductTeamCollaborationRoute
  ReleaseNotesSlugRoute: typeof ReleaseNotesSlugRoute
  ServicesMaitoSetupRoute: typeof ServicesMaitoSetupRoute
  SourceControlCallbackRoute: typeof SourceControlCallbackRoute
  UseCasesAgenciesRoute: typeof UseCasesAgenciesRoute
  UseCasesEngineeringRoute: typeof UseCasesEngineeringRoute
  UseCasesProductRoute: typeof UseCasesProductRoute
  UseCasesQaRoute: typeof UseCasesQaRoute
  UseCasesSupportRoute: typeof UseCasesSupportRoute
  WorkflowsSlugRoute: typeof WorkflowsSlugRoute
  BlogCategoryAiNewsRoute: typeof BlogCategoryAiNewsRoute
  IntegrationsCategoryCategoryRoute: typeof IntegrationsCategoryCategoryRoute
  WorkflowsIndustryIndustryRoute: typeof WorkflowsIndustryIndustryRoute
  WorkflowsTeamTeamRoute: typeof WorkflowsTeamTeamRoute
  WorkflowsToolToolRoute: typeof WorkflowsToolToolRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/workflows': {
      id: '/workflows'
      path: '/workflows'
      fullPath: '/workflows'
      preLoaderRoute: typeof WorkflowsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms-of-service': {
      id: '/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/terms-of-service'
      preLoaderRoute: typeof TermsOfServiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/release-notes': {
      id: '/release-notes'
      path: '/release-notes'
      fullPath: '/release-notes'
      preLoaderRoute: typeof ReleaseNotesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations': {
      id: '/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof IntegrationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/homepage': {
      id: '/homepage'
      path: '/homepage'
      fullPath: '/homepage'
      preLoaderRoute: typeof HomepageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq': {
      id: '/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof FaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compare': {
      id: '/compare'
      path: '/compare'
      fullPath: '/compare'
      preLoaderRoute: typeof CompareRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/changelog': {
      id: '/changelog'
      path: '/changelog'
      fullPath: '/changelog'
      preLoaderRoute: typeof ChangelogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog': {
      id: '/blog'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof BlogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_workspace': {
      id: '/_workspace'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof WorkspaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_workspace/': {
      id: '/_workspace/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof WorkspaceIndexRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/workflows_/$slug': {
      id: '/workflows_/$slug'
      path: '/workflows/$slug'
      fullPath: '/workflows/$slug'
      preLoaderRoute: typeof WorkflowsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/use-cases/support': {
      id: '/use-cases/support'
      path: '/use-cases/support'
      fullPath: '/use-cases/support'
      preLoaderRoute: typeof UseCasesSupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/use-cases/qa': {
      id: '/use-cases/qa'
      path: '/use-cases/qa'
      fullPath: '/use-cases/qa'
      preLoaderRoute: typeof UseCasesQaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/use-cases/product': {
      id: '/use-cases/product'
      path: '/use-cases/product'
      fullPath: '/use-cases/product'
      preLoaderRoute: typeof UseCasesProductRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/use-cases/engineering': {
      id: '/use-cases/engineering'
      path: '/use-cases/engineering'
      fullPath: '/use-cases/engineering'
      preLoaderRoute: typeof UseCasesEngineeringRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/use-cases/agencies': {
      id: '/use-cases/agencies'
      path: '/use-cases/agencies'
      fullPath: '/use-cases/agencies'
      preLoaderRoute: typeof UseCasesAgenciesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/source-control/callback': {
      id: '/source-control/callback'
      path: '/source-control/callback'
      fullPath: '/source-control/callback'
      preLoaderRoute: typeof SourceControlCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/maito-setup': {
      id: '/services/maito-setup'
      path: '/services/maito-setup'
      fullPath: '/services/maito-setup'
      preLoaderRoute: typeof ServicesMaitoSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/release-notes_/$slug': {
      id: '/release-notes_/$slug'
      path: '/release-notes/$slug'
      fullPath: '/release-notes/$slug'
      preLoaderRoute: typeof ReleaseNotesSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/product/team-collaboration': {
      id: '/product/team-collaboration'
      path: '/product/team-collaboration'
      fullPath: '/product/team-collaboration'
      preLoaderRoute: typeof ProductTeamCollaborationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/product/skills': {
      id: '/product/skills'
      path: '/product/skills'
      fullPath: '/product/skills'
      preLoaderRoute: typeof ProductSkillsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/product/company-knowledge': {
      id: '/product/company-knowledge'
      path: '/product/company-knowledge'
      fullPath: '/product/company-knowledge'
      preLoaderRoute: typeof ProductCompanyKnowledgeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations_/$slug': {
      id: '/integrations_/$slug'
      path: '/integrations/$slug'
      fullPath: '/integrations/$slug'
      preLoaderRoute: typeof IntegrationsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compare_/$slug': {
      id: '/compare_/$slug'
      path: '/compare/$slug'
      fullPath: '/compare/$slug'
      preLoaderRoute: typeof CompareSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/changelog_/$slug': {
      id: '/changelog_/$slug'
      path: '/changelog/$slug'
      fullPath: '/changelog/$slug'
      preLoaderRoute: typeof ChangelogSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog_/$slug': {
      id: '/blog_/$slug'
      path: '/blog/$slug'
      fullPath: '/blog/$slug'
      preLoaderRoute: typeof BlogSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_workspace/vault': {
      id: '/_workspace/vault'
      path: '/vault'
      fullPath: '/vault'
      preLoaderRoute: typeof WorkspaceVaultRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/usage': {
      id: '/_workspace/usage'
      path: '/usage'
      fullPath: '/usage'
      preLoaderRoute: typeof WorkspaceUsageRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/slack': {
      id: '/_workspace/slack'
      path: '/slack'
      fullPath: '/slack'
      preLoaderRoute: typeof WorkspaceSlackRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/skills': {
      id: '/_workspace/skills'
      path: '/skills'
      fullPath: '/skills'
      preLoaderRoute: typeof WorkspaceSkillsRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/repositories': {
      id: '/_workspace/repositories'
      path: '/repositories'
      fullPath: '/repositories'
      preLoaderRoute: typeof WorkspaceRepositoriesRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/providers': {
      id: '/_workspace/providers'
      path: '/providers'
      fullPath: '/providers'
      preLoaderRoute: typeof WorkspaceProvidersRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/profile': {
      id: '/_workspace/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof WorkspaceProfileRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/overview': {
      id: '/_workspace/overview'
      path: '/overview'
      fullPath: '/overview'
      preLoaderRoute: typeof WorkspaceOverviewRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/members': {
      id: '/_workspace/members'
      path: '/members'
      fullPath: '/members'
      preLoaderRoute: typeof WorkspaceMembersRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/mcp': {
      id: '/_workspace/mcp'
      path: '/mcp'
      fullPath: '/mcp'
      preLoaderRoute: typeof WorkspaceMcpRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/loops': {
      id: '/_workspace/loops'
      path: '/loops'
      fullPath: '/loops'
      preLoaderRoute: typeof WorkspaceLoopsRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/logs': {
      id: '/_workspace/logs'
      path: '/logs'
      fullPath: '/logs'
      preLoaderRoute: typeof WorkspaceLogsRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/knowledge': {
      id: '/_workspace/knowledge'
      path: '/knowledge'
      fullPath: '/knowledge'
      preLoaderRoute: typeof WorkspaceKnowledgeRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/general': {
      id: '/_workspace/general'
      path: '/general'
      fullPath: '/general'
      preLoaderRoute: typeof WorkspaceGeneralRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/environments': {
      id: '/_workspace/environments'
      path: '/environments'
      fullPath: '/environments'
      preLoaderRoute: typeof WorkspaceEnvironmentsRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/email': {
      id: '/_workspace/email'
      path: '/email'
      fullPath: '/email'
      preLoaderRoute: typeof WorkspaceEmailRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/create': {
      id: '/_workspace/create'
      path: '/create'
      fullPath: '/create'
      preLoaderRoute: typeof WorkspaceCreateRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/connections': {
      id: '/_workspace/connections'
      path: '/connections'
      fullPath: '/connections'
      preLoaderRoute: typeof WorkspaceConnectionsRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/chat': {
      id: '/_workspace/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof WorkspaceChatRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/archived': {
      id: '/_workspace/archived'
      path: '/archived'
      fullPath: '/archived'
      preLoaderRoute: typeof WorkspaceArchivedRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/workflows_/tool/$tool': {
      id: '/workflows_/tool/$tool'
      path: '/workflows/tool/$tool'
      fullPath: '/workflows/tool/$tool'
      preLoaderRoute: typeof WorkflowsToolToolRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workflows_/team/$team': {
      id: '/workflows_/team/$team'
      path: '/workflows/team/$team'
      fullPath: '/workflows/team/$team'
      preLoaderRoute: typeof WorkflowsTeamTeamRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workflows_/industry/$industry': {
      id: '/workflows_/industry/$industry'
      path: '/workflows/industry/$industry'
      fullPath: '/workflows/industry/$industry'
      preLoaderRoute: typeof WorkflowsIndustryIndustryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations_/category/$category': {
      id: '/integrations_/category/$category'
      path: '/integrations/category/$category'
      fullPath: '/integrations/category/$category'
      preLoaderRoute: typeof IntegrationsCategoryCategoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog_/category/ai-news': {
      id: '/blog_/category/ai-news'
      path: '/blog/category/ai-news'
      fullPath: '/blog/category/ai-news'
      preLoaderRoute: typeof BlogCategoryAiNewsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_workspace/home/{-$loop}': {
      id: '/_workspace/home/{-$loop}'
      path: '/home/{-$loop}'
      fullPath: '/home/{-$loop}'
      preLoaderRoute: typeof WorkspaceHomeChar123LoopChar125RouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/connections_/mcp': {
      id: '/_workspace/connections_/mcp'
      path: '/connections/mcp'
      fullPath: '/connections/mcp'
      preLoaderRoute: typeof WorkspaceConnectionsMcpRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/activity/{-$loop}': {
      id: '/_workspace/activity/{-$loop}'
      path: '/activity/{-$loop}'
      fullPath: '/activity/{-$loop}'
      preLoaderRoute: typeof WorkspaceActivityChar123LoopChar125RouteImport
      parentRoute: typeof WorkspaceRoute
    }
  }
}

interface WorkspaceRouteChildren {
  WorkspaceArchivedRoute: typeof WorkspaceArchivedRoute
  WorkspaceChatRoute: typeof WorkspaceChatRoute
  WorkspaceConnectionsRoute: typeof WorkspaceConnectionsRoute
  WorkspaceCreateRoute: typeof WorkspaceCreateRoute
  WorkspaceEmailRoute: typeof WorkspaceEmailRoute
  WorkspaceEnvironmentsRoute: typeof WorkspaceEnvironmentsRoute
  WorkspaceGeneralRoute: typeof WorkspaceGeneralRoute
  WorkspaceKnowledgeRoute: typeof WorkspaceKnowledgeRoute
  WorkspaceLogsRoute: typeof WorkspaceLogsRoute
  WorkspaceLoopsRoute: typeof WorkspaceLoopsRoute
  WorkspaceMcpRoute: typeof WorkspaceMcpRoute
  WorkspaceMembersRoute: typeof WorkspaceMembersRoute
  WorkspaceOverviewRoute: typeof WorkspaceOverviewRoute
  WorkspaceProfileRoute: typeof WorkspaceProfileRoute
  WorkspaceProvidersRoute: typeof WorkspaceProvidersRoute
  WorkspaceRepositoriesRoute: typeof WorkspaceRepositoriesRoute
  WorkspaceSkillsRoute: typeof WorkspaceSkillsRoute
  WorkspaceSlackRoute: typeof WorkspaceSlackRoute
  WorkspaceUsageRoute: typeof WorkspaceUsageRoute
  WorkspaceVaultRoute: typeof WorkspaceVaultRoute
  WorkspaceIndexRoute: typeof WorkspaceIndexRoute
  WorkspaceActivityChar123LoopChar125Route: typeof WorkspaceActivityChar123LoopChar125Route
  WorkspaceConnectionsMcpRoute: typeof WorkspaceConnectionsMcpRoute
  WorkspaceHomeChar123LoopChar125Route: typeof WorkspaceHomeChar123LoopChar125Route
}

const WorkspaceRouteChildren: WorkspaceRouteChildren = {
  WorkspaceArchivedRoute: WorkspaceArchivedRoute,
  WorkspaceChatRoute: WorkspaceChatRoute,
  WorkspaceConnectionsRoute: WorkspaceConnectionsRoute,
  WorkspaceCreateRoute: WorkspaceCreateRoute,
  WorkspaceEmailRoute: WorkspaceEmailRoute,
  WorkspaceEnvironmentsRoute: WorkspaceEnvironmentsRoute,
  WorkspaceGeneralRoute: WorkspaceGeneralRoute,
  WorkspaceKnowledgeRoute: WorkspaceKnowledgeRoute,
  WorkspaceLogsRoute: WorkspaceLogsRoute,
  WorkspaceLoopsRoute: WorkspaceLoopsRoute,
  WorkspaceMcpRoute: WorkspaceMcpRoute,
  WorkspaceMembersRoute: WorkspaceMembersRoute,
  WorkspaceOverviewRoute: WorkspaceOverviewRoute,
  WorkspaceProfileRoute: WorkspaceProfileRoute,
  WorkspaceProvidersRoute: WorkspaceProvidersRoute,
  WorkspaceRepositoriesRoute: WorkspaceRepositoriesRoute,
  WorkspaceSkillsRoute: WorkspaceSkillsRoute,
  WorkspaceSlackRoute: WorkspaceSlackRoute,
  WorkspaceUsageRoute: WorkspaceUsageRoute,
  WorkspaceVaultRoute: WorkspaceVaultRoute,
  WorkspaceIndexRoute: WorkspaceIndexRoute,
  WorkspaceActivityChar123LoopChar125Route:
    WorkspaceActivityChar123LoopChar125Route,
  WorkspaceConnectionsMcpRoute: WorkspaceConnectionsMcpRoute,
  WorkspaceHomeChar123LoopChar125Route: WorkspaceHomeChar123LoopChar125Route,
}

const WorkspaceRouteWithChildren = WorkspaceRoute._addFileChildren(
  WorkspaceRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  WorkspaceRoute: WorkspaceRouteWithChildren,
  AboutRoute: AboutRoute,
  AdminRoute: AdminRoute,
  BlogRoute: BlogRoute,
  ChangelogRoute: ChangelogRoute,
  CompareRoute: CompareRoute,
  FaqRoute: FaqRoute,
  HomepageRoute: HomepageRoute,
  IntegrationsRoute: IntegrationsRoute,
  LoginRoute: LoginRoute,
  PricingRoute: PricingRoute,
  PrivacyRoute: PrivacyRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  ReleaseNotesRoute: ReleaseNotesRoute,
  TermsRoute: TermsRoute,
  TermsOfServiceRoute: TermsOfServiceRoute,
  WorkflowsRoute: WorkflowsRoute,
  BlogSlugRoute: BlogSlugRoute,
  ChangelogSlugRoute: ChangelogSlugRoute,
  CompareSlugRoute: CompareSlugRoute,
  IntegrationsSlugRoute: IntegrationsSlugRoute,
  ProductCompanyKnowledgeRoute: ProductCompanyKnowledgeRoute,
  ProductSkillsRoute: ProductSkillsRoute,
  ProductTeamCollaborationRoute: ProductTeamCollaborationRoute,
  ReleaseNotesSlugRoute: ReleaseNotesSlugRoute,
  ServicesMaitoSetupRoute: ServicesMaitoSetupRoute,
  SourceControlCallbackRoute: SourceControlCallbackRoute,
  UseCasesAgenciesRoute: UseCasesAgenciesRoute,
  UseCasesEngineeringRoute: UseCasesEngineeringRoute,
  UseCasesProductRoute: UseCasesProductRoute,
  UseCasesQaRoute: UseCasesQaRoute,
  UseCasesSupportRoute: UseCasesSupportRoute,
  WorkflowsSlugRoute: WorkflowsSlugRoute,
  BlogCategoryAiNewsRoute: BlogCategoryAiNewsRoute,
  IntegrationsCategoryCategoryRoute: IntegrationsCategoryCategoryRoute,
  WorkflowsIndustryIndustryRoute: WorkflowsIndustryIndustryRoute,
  WorkflowsTeamTeamRoute: WorkflowsTeamTeamRoute,
  WorkflowsToolToolRoute: WorkflowsToolToolRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
